import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCheckCircle, faInbox, faBell, faHome, faHamburger, faPowerOff, faSignOutAlt, faBars, faChevronLeft, faShoppingBag, faShoppingBasket, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { BusinessIntelligenceService } from 'src/app/services/business-intelligence/business-intelligence.service';
import { ManualOrderService } from 'src/app/services/manual-order/manual-order.service';

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent implements OnInit {

  faChevronLeft = faChevronLeft
  faShoppingBasket = faShoppingBag
  faChevronRight = faChevronRight


  prosummer = [
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/dc9e619bc6ac2bc59d17d0bcaff58b3f.webp',
      'title': ' Dji Mini',
      'desc': 'Mini to The Max',
      'link': ''
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/9f9b989bf3469fd371376e08235724dc.webp',
      'title': 'Osmo Action 4',
      'desc': 'Mini to The Max',
      'link': ''
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/df2248122303c9a90b7c65d2f7ae665d.webp',
      'title': 'Accessories',
      'desc': 'Mini to The Max',
      'link': ''
    },
    {
      'img': 'https://www-cdn.djiits.com/cms/uploads/6cbcec2f6e38efdccad35fa1c810e10d.webp',
      'title': ' Dji Mini',
      'desc': 'Mini to The Max',
      'link': ''
    }
  ]

  isSticky: boolean;
  isShowCTA: boolean;
  regis_id: string;
  faBars = faBars
  catalog_nav: any;
  main_nav: any;
  @HostListener('window:scroll', ['$event'])
  doSomething(event) {
    this.isSticky = window.pageYOffset >= 20;

    this.isShowCTA = window.pageYOffset >= window.innerHeight;

  }


  faInbox = faInbox
  faSignOutAlt = faSignOutAlt
  faHamburger = faHamburger
  faTasks = faCheckCircle
  faCheckCircle = faCheckCircle
  faPowerOff = faPowerOff
  faHome = faHome
  faBell = faBell
  user_account: any;
  notification: any;
  showModal: any;
  inital_name: any;
  notification_count: any;
  constructor(
    private appService: BusinessIntelligenceService,
    private webService: ManualOrderService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }



  ngOnInit(): void {
    // this.webService.userSessionSubject.subscribe(
    //   (res) => {

    //     console.log(res)
    //     if (res) {
    //       this.user_account = res


    //       this.inital_name = this.user_account.first_name.charAt(0) + this.user_account.last_name.charAt(0)
    //     }
    //   }
    // )
    this.getCategory()



    //  this.playSound('https://assets.mixkit.co/active_storage/sfx/2870/2870-preview.mp3')
  }






  playSound(url) {
    const audio = new Audio(url);
    audio.play();
  }

  openModal(modal) {
    this.showModal = modal
  }
  closeModal() {
    this.showModal = null
  }

  navTo(item) {
    console.log(item)
    this.router.navigate(
      [item]
    );
    this.showModal = false
  }

  async userLogout() {


    try {
      localStorage.removeItem("device_session");


      this.router.navigate(
        ['/dashboard/login']
      );



    } catch (e) {

      this.appService.openToast(e)


      console.log(e)
    } finally {
      this.user_account = null
      this.appService.openToast('Logout Success')

    }
  }



  async getCategory() {


    try {
      let response = await this.webService.getCategory('?parrent_id=0');
      console.log(response);
      this.main_nav = response.data;
    } catch (e) {
      console.log(e);
    }
  }


  navigateTo(item: any): void {
    this.showModal = false
    if (!item || !item.id) {
      console.warn('Invalid item passed to navigateTo:', item);
      return;
    }

    this.router.navigate(
      ['/catalog/view/' + item.name], // pastikan slash awal kalau absolute path
      { queryParams: { parrent_id: item.id } }
    );

  }






}
